import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { TileMinZoom } from '../../constants/data';

interface UiState {
  sortingCollapsed: boolean;
  workspaceCollapsed: boolean;
  workspaceModalStatus: boolean;
  welcomeModalStatus: boolean;
  zoom: number;
}

const initialState: UiState = {
  sortingCollapsed: false,
  workspaceCollapsed: true,
  workspaceModalStatus: false,
  welcomeModalStatus: false,
  zoom: TileMinZoom,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSorting: (state) => {
      state.sortingCollapsed = !state.sortingCollapsed;
      return state;
    },
    statusWorkspaceModal: (state, { payload }: PayloadAction<boolean>) => {
      state.workspaceModalStatus = payload;
      return state;
    },
    statusWelcomeModal: (state, { payload }: PayloadAction<boolean>) => {
      state.welcomeModalStatus = payload;
      return state;
    },
    changeZoom: (state, { payload }: PayloadAction<number>) => {
      state.zoom = payload;
      return state;
    },
  },
});

export const {
  statusWelcomeModal,
  statusWorkspaceModal,
  changeZoom,
} = uiSlice.actions;
